import { Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';
import { globalColors } from '../../../../../../../../_metronic/_assets/sass/custom/globalColors';
import { ReactComponent as IconCircleRight } from '../../../../../../../assets/icons/icon_circle-chevron-right-fill.svg';
import InputForm from '../../../../../../../components/InputForm';
import { AppAPIService } from '../../../../../../../services/AppAPIService';
import { Button } from './styles';

export const ClassesProcessuaisSelect = ({ setIsLoading, setReload, reload }) => {
  let api = AppAPIService.getInstance();

  const [proceduralClassOptions, setProceduralClassOptions] = useState([]);

  const [proceduralClasses, setProceduralClasses] = useState('');
  const onChangeProceduralClass = (proceduralClass) => {
    if (!proceduralClass) {
      setProceduralClasses([]);
    }

    if (proceduralClass?.length) {
      setProceduralClasses(proceduralClass);
    }
  };

  const getProceduralClasses = async () => {
    setIsLoading(true);

    try {
      const proceduralClasses = await api.makeHttpRequest({
        url: 'process-class/list',
        method: 'GET',
      });

      setProceduralClassOptions(
        proceduralClasses?.map((proceduralClass) => ({
          label: proceduralClass.value,
          value: proceduralClass.key,
        }))
      );

      setIsLoading(false);
    } catch {
      setIsLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Erro ao buscar classes processuais.',
      });
    }
  };

  useEffect(() => {
    getProceduralClasses();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      setIsLoading(true);
      e.preventDefault();
      try {
        setIsLoading(true);

        for await (const proceduralClass of proceduralClasses) {
          await api.makeHttpRequest({
            url: '/procedural-class',
            method: 'POST',
            data: {
              text: proceduralClass.label.split('- ')[1],
              value: String(proceduralClass.value),
            },
          });
        }

        setIsLoading(false);
        setProceduralClasses('');

        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Classe processual cadastrada com sucesso',
        });

        setReload(!reload);
      } catch (error) {
        setIsLoading(false);

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Erro ao criar classe processual.',
        });
      } finally {
        setIsLoading(false);
      }
    },
    [api, proceduralClasses, reload, setIsLoading, setReload]
  );

  const isFormInvalid = useMemo(() => proceduralClasses === '', [proceduralClasses]);

  return (
    <Grid
      container
      style={{
        padding: '18px 0 9px',
      }}
    >
      <Grid sm={10} style={{ backgroundColor: 'white' }}>
        <InputForm
          type="text"
          isSelect
          options={proceduralClassOptions}
          name="name"
          placeholder="Digite o nome da Classe Processual"
          label="Nome"
          value={proceduralClasses}
          required
          onChange={onChangeProceduralClass}
          isClearable
          isMulti
          height="fit-content !important"
        />
      </Grid>
      <Grid
        sm={2}
        style={{
          padding: '0 18px',
        }}
      >
        <Button
          variant="primary"
          type="submit"
          color={globalColors.primaryColor2}
          onClick={onSubmit}
          disabled={isFormInvalid}
          title={isFormInvalid ? 'Salvar dados' : 'Verifique os campos'}
          // submitText={submitText}
        >
          <span className="text-light">
            Salvar <IconCircleRight />
          </span>
        </Button>
      </Grid>
    </Grid>
  );
};
